import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

const PageViewTracker = ({ settings, settingsLoaded = false }) => {
  const { pathname, search } = useLocation();
  const gaId = settings?.google_analytics_id;

  useEffect(() => {
    if (!settingsLoaded) return;
    trackPageView(`${pathname}${search}`, gaId);
  }, [pathname, search, gaId, settingsLoaded]);

  return null;
};

export default PageViewTracker;
